exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-form td[data-v-52aa07e6]:last-child{border-right:none}.table-form .table-body tr[data-v-52aa07e6]:last-child{border:none}.table-form .table-body td[data-v-52aa07e6]:first-child{border-left:none}[data-v-52aa07e6] .el-card .el-card__header{padding:10px}[data-v-52aa07e6] .custom-card{border-bottom:none!important}[data-v-52aa07e6] .el-card .el-card__header{padding:0!important}", ""]);

// exports
